
<!-- TODO: Component can probably be merged with Proposal.vue -->
<template>
  <section class="proposal">
    <page-error-iquote-not-found v-if="notFound"></page-error-iquote-not-found>

    <page-error v-else-if="error"></page-error>
    <page-error-iquote-not-correct v-else-if="dataError"></page-error-iquote-not-correct>

    <div v-else>
      <div class="container container-full-width-small px-0">
        <router-view></router-view>
      </div>
    </div>
  </section>
</template>

<script>

import { mapGetters } from 'vuex'
import PageErrorIquoteNotFound from '@/components/main/error/PageErrorIquoteNotFound'
import PageError from '@/components/main/error/PageError'
import PageErrorIquoteNotCorrect from '@/components/main/error/PageErrorIquoteNotCorrect'

export default {
  name: 'B2bProposal',
  components: {
    PageErrorIquoteNotFound,
    PageError,
    PageErrorIquoteNotCorrect,
  },
  computed: {
    ...mapGetters(['loadingError']),
    notFound() {
      return this.loadingError === 'NOT_FOUND'
    },
    error() {
      return this.loadingError === 'ERROR'
    },
    dataError() {
      return this.loadingError === 'DATA_ERROR'
    },
  }
}

</script>


